import moment from 'moment'
import realEstateService from '@/services/realEstateService.js'

const state = {
  advisers: [],
  datos: {
    areaConstruida: '',
    areaLote: '',
    areaTerraza: '',
    asesor: '',
    asesorVenta: '',
    asesorArriendo: '',
    destacado: '',
    estado: '',
    fechaDeCreacion: moment().format('DD/MM/YYYY'),
    frecuenciaPredial: '',
    habilitarEnLaWeb: '',
    ordenDestacado: '',
    properties: [],
    propietario: '',
    proposito: '',
    tipoDePropiedad: '',
    avaluoCatastral: '',
    valorDeAdministracion: '',
    valorDeVenta: '',
    valorDeArriendo: '',
    valorPredial: ''
  },
  despublicar: {
    fecha: '',
    razon: 0,
    valor: '',
    vendidoOArrendadoPor: ''
  },
  neighborhoods: [],
  owners: [],
  properties: [],
  sectors: [],
  totalProperties: 0,
  zones: []
}

const mutations = {
  SET_REAL_ESTATE_ADVISERS (state, advisers) {
    state.advisers = advisers
  },
  'SET_FECHA_DE_CREACION' (state, date) {
    state.fechaDeCreacion = date ? new Date(date) : new Date()
  },
  'SET_NEIGHBORHOODS' (state, neighborhoods) {
    state.neighborhoods = neighborhoods
  },
  'SET_OWNERS' (state, owners) {
    state.owners = owners
  },
  'SET_PROPERTIES' (state, properties) {
    state.properties = properties
  },
  'SET_SECTORS' (state, sectors) {
    state.sectors = sectors
  },
  'SET_TOTAL_PROPERTIES' (state, totalProperties) {
    state.totalProperties = totalProperties
  },
  'SET_ZONES' (state, zones) {
    state.zones = zones
  }
}

const actions = {
  async getRealEstateAdvisers (vuexContext) {
    vuexContext.commit('SET_REAL_ESTATE_ADVISERS', await realEstateService.getRealEstateAdvisers())
    return true
  },
  async getNeighborhoods (vuexContext, sector) {
    if (!sector) {
      vuexContext.commit('SET_NEIGHBORHOODS', [])
    } else {
      vuexContext.commit('SET_NEIGHBORHOODS', await realEstateService.getNeighborhoods(sector))
    }
    return true
  },
  async getOwners (vuexContext) {
    try {
      vuexContext.commit('SET_OWNERS', await realEstateService.getOwners())
      return true
    } catch (e) {
      vuexContext.commit('SET_OWNERS', [])
      return false
    }
  },
  async getProperties (vuexContext, data) {
    const response = await realEstateService.getProperties(data)
    vuexContext.commit('SET_PROPERTIES', response.inmuebles)
    vuexContext.commit('SET_TOTAL_PROPERTIES', response.total)
    return true
  },
  async getSectors (vuexContext, zone) {
    if (!zone) {
      vuexContext.commit('SET_SECTORS', [])
    } else {
      vuexContext.commit('SET_SECTORS', await realEstateService.getSectors(zone))
    }
    return true
  },
  async getZones (vuexContext) {
    vuexContext.commit('SET_ZONES', await realEstateService.getZones())
    return true
  }
}

const getters = {}

export default { state, mutations, actions, getters }
